export default {
    '1b-diagram1': {
        'diagram-task': 'Drag each point to its proper place in the pyramid',
        'fixed-answer': 'Firestone’s most important commitment was his initial move to Akron',
        'element_1_1': 'Ecosystem of supporting institutions',
        'element_1_2': 'Place to socialize and talk shop',
        'element_1_3': 'On the cutting edge of rubber technology'
    }
}


// WEBPACK FOOTER //
// ./client/app/components/diagrams/1/1b/diagram1/i18n/en.js